export const Base = {
    name: 'Bolt',
    txtForLogo: false,
    fixedNav: false,
    logoOnMenu: true,
    logoOnTopBar: true,
    logo: './../assets/media/logo.png',
    smallLogo: './../assets/media/logo-mini.png',
    darkMenu: false,
    darkTopBar: false,
    topBar: {
        hiddableMenu: false,
        search: false,
        sidebar: false,
        notification: true,
        blackMenuOpt: false
    },
    footer: {
        year: '2018'
    }
};